import { useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import ChampMotDePasse from "../components/ChampMotDePasse";

export default function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [erreur, setErreur] = useState("");
  const [sessionExpiree, setSessionExpiree] = useState(
    () => new URLSearchParams(window.location.search).get("expired") === "1"
  );

  const soumettre = async (e) => {
    e.preventDefault();
    setErreur("");
    setSessionExpiree(false);
    try {
      const params = new URLSearchParams();
      params.append("username", email);
      params.append("password", motDePasse);
      const { data } = await api.post("/login", params);
      onLogin(data.access_token, data.user);
    } catch (err) {
      const statut = err?.response?.status;
      if (statut === 401) {
        // Vrai refus d'authentification renvoye par le backend.
        setErreur("Identifiants invalides");
      } else if (statut === 429) {
        // Blocage brute-force : on affiche le message precis du backend.
        setErreur(
          err?.response?.data?.detail ||
            "Trop de tentatives. Reessayez dans quelques minutes."
        );
      } else if (err?.response) {
        setErreur("Une erreur est survenue. Reessayez plus tard.");
      } else {
        // Pas de reponse : backend injoignable ou requete bloquee (CORS/reseau).
        setErreur("Serveur injoignable. Verifiez votre connexion.");
      }
    }
  };

  return (
    <div className="login-page">
      {/* LA MARQUE EST CELLE DU PRODUIT, PAS CELLE D'UN CLIENT.
          Avant la connexion, l'application ne sait pas a quel client
          appartient la personne : afficher le logo d'une entreprise
          reviendrait a le montrer aux salaries de toutes les autres. La
          charte du client s'applique une fois entre (voir marque.js). */}
      <div className="login-panel-gauche">
        <div className="login-marque-bloc">
          {/* Le logo est une IMAGE, et elle peut manquer : sur une
              installation ou le fichier n'a pas ete depose, `onError` bascule
              sur le nom en toutes lettres. Un carre vide a la place d'un logo
              fait plus de mal qu'un mot. */}
          <img
            className="login-logo"
            src="/logos/ridelle.png"
            alt="Ridelle"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
          <p className="login-marque">Ridelle</p>
          <p className="login-tagline">Votre gestionnaire de parc</p>
        </div>
      </div>

      <div className="login-panel-droite">
        <form className="login-form" onSubmit={soumettre}>
          <h2 className="login-titre">Connexion</h2>
          <p className="login-sous-titre">
            Entrez vos identifiants pour accéder à votre flotte.
          </p>

          {sessionExpiree && (
            <div className="info-session">
              Votre session a expiré, veuillez vous reconnecter.
            </div>
          )}
          {erreur && <div className="erreur">{erreur}</div>}

          <div className="login-champ">
            <label htmlFor="login-email">Email</label>
            <input
              id="login-email"
              type="email"
              placeholder="votre@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {/* L'oeil, ici plus qu'ailleurs : les mots de passe sont transmis
              de vive voix et font douze caracteres. Une faute de frappe
              invisible se solde par un refus qui ne dit pas ou est l'erreur,
              et au cinquieme essai le compte se verrouille quinze minutes. */}
          <ChampMotDePasse
            className="login-champ"
            label="Mot de passe"
            value={motDePasse}
            onChange={setMotDePasse}
            placeholder="••••••••"
            autoComplete="current-password"
            required
          />

          <button className="btn-accent login-btn" type="submit">
            Se connecter
          </button>

          <p className="login-oubli">
            <Link to="/mot-de-passe-oublie">Mot de passe oublié ?</Link>
          </p>

          {/* L'adresse du site est la SEULE chose qui prouve a l'utilisateur
              qu'il est au bon endroit. La rappeler sous le formulaire coute
              une ligne et vaut mieux qu'un discours sur la securite. */}
          <p className="login-pied">
            Espace sécurisé — <strong>app.ridelle.fr</strong>
          </p>
        </form>
      </div>
    </div>
  );
}
